import { startCase } from 'lodash-es'
import { FormField, MultiLanguageString, RegistrationConsentItem, TraitWrapper } from 'types'

export const defaultFormSections = [
  'region',
  'disclaimer',
  'basicFields',
  'optIn',
  'additionalFields',
]

export interface FormSectionData {
  region?: 'default' | 'row'
  disclaimer?: { text: MultiLanguageString }
  basicFields?: FormField[]
  additionalFields?: { [key: number]: TraitWrapper }
  optIn?: string | RegistrationConsentItem[]
}

export const formTextProps: Record<string, string> = {
  textStyle: 'bodySmall',
  fontWeight: '500',
}

export function getSectionHeader(sectionName: string) {
  switch (sectionName) {
    case 'disclaimer':
      return 'Registration Disclaimer'
    case 'basicFields':
      return 'The Basics'
    case 'additionalFields':
      return 'Additional Questions'
    case 'optIn':
      return 'Marketing Opt-In'
    case 'region':
      return 'Residence'
    default:
      return startCase(sectionName)
  }
}
